// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/star.js';

import { paths } from '../generated/star';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('star', Original, paths);
